function BeerPouring2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={64} height={130} id="beer-pouring-2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M.573 2.47h63.191c.545 50.866-22.736 101.7-11.819 125.233A2.313 2.313 0 0149.642 130H14.696a2.312 2.312 0 01-2.303-2.297C23.311 104.17.03 53.336.573 2.469z"
        fill="#C0BFBF"
      />
      <path
        d="M2.734 4.438H61.61c0 52.421-17.945 87.162-13.458 115.412H16.193C20.68 91.6 2.734 56.86 2.734 4.438z"
        fill="#D4D4D4"
      />
      <path
        d="M29.778 94.464a2.384 2.384 0 002.387 2.382c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38a2.384 2.384 0 00-2.387 2.38z"
        fill="#D4D4D4"
      />
      <path
        d="M44.134 59.911a3.124 3.124 0 003.128 3.118 3.123 3.123 0 003.129-3.118c0-1.724-1.4-3.12-3.129-3.12a3.125 3.125 0 00-3.128 3.12z"
        fill="#F8F8F8"
      />
      <path
        d="M32.168 130h17.473a2.313 2.313 0 002.304-2.297c-2.079-4.482-2.919-9.952-2.917-16.227C49.03 85.195 63.77 44.84 63.773 4.258c0-.597-.004-1.192-.01-1.789H32.169v1.968h29.437c0 52.422-17.945 87.162-13.458 115.412H32.168V130z"
        fill="#999"
      />
      <path
        d="M32.172 119.85H48.15C43.664 91.6 61.609 56.86 61.609 4.438H32.172v87.647c1.32 0 2.39 1.065 2.39 2.38a2.385 2.385 0 01-2.39 2.381v23.004zm15.095-63.062a3.123 3.123 0 013.129 3.12c0 1.723-1.4 3.12-3.129 3.12a3.124 3.124 0 01-3.128-3.12 3.125 3.125 0 013.128-3.12z"
        fill="#D4D4D4"
      />
      <path
        d="M32.165 96.846c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38v4.762zM47.262 63.03a3.123 3.123 0 003.129-3.119c0-1.724-1.4-3.12-3.129-3.12a3.125 3.125 0 00-3.128 3.12 3.124 3.124 0 003.128 3.118z"
        fill="#D4D4D4"
      />
      <path
        d="M9.715 5.543H4.31c-.692 32.6 15.105 75.56 14.275 113.409C21.632 67.704 9.08 53.85 9.715 5.543z"
        fill="#F8F8F8"
      />
      <path
        d="M43.11 41.268c0 1.745.93 3.16 2.077 3.16 1.148 0 2.079-1.415 2.079-3.16 0-1.746-.931-3.16-2.08-3.16-1.146 0-2.077 1.414-2.077 3.16zM19.499 35.778a3.125 3.125 0 003.13 3.118 3.124 3.124 0 003.129-3.118 3.125 3.125 0 00-3.129-3.12 3.125 3.125 0 00-3.13 3.12zM20.491 25.023a4.193 4.193 0 004.2 4.186c2.32 0 4.2-1.874 4.2-4.186 0-2.311-1.88-4.187-4.2-4.187a4.195 4.195 0 00-4.2 4.187z"
        fill="#D4D4D4"
      />
      <ellipse cx={32.228} cy={3.277} rx={31.744} ry={3.277} fill="#F8F8F8" />
      <path
        d="M46.91 106.256s3.2-8.064-1.487-11.426c-1.396-1-5.248-.501-9.206-.005-2.497.313-5.037.628-7.027.566-5.449-.173-8.32-2.414-11.45-.224-3.1 3.025.004 11.089.004 11.089H46.91z"
        fill="#F8F8F8"
      />
      <path
        d="M16.365 99.106c1.506 15.054-.188 19.192-.552 21.065H48.65s-.894-5.709-1.048-9.399c-.172-4.114.376-10.537.376-10.537s-8.28 0-15.43 4.139c-7.151 4.14-16.184-5.268-16.184-5.268z"
        fill="url(#prefix__paint0_linear_14338_42015)"
      />
      <path
        d="M22.004 109.267a1.13 1.13 0 100-2.258 1.13 1.13 0 000 2.258zM41.2 113.03a1.506 1.506 0 103.011 0 1.506 1.506 0 00-3.01 0z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_14338_42015"
          x1={48.732}
          y1={116.041}
          x2={15.613}
          y2={116.041}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAF3F" />
          <stop offset={1} stopColor="#F89730" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default BeerPouring2;
